var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.WMenuList,[_c(_setup.WMenuItem,[_c(_setup.WHeaderSearch,{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]})],1),(!_vm.isWavveOn)?_c(_setup.WMenuItem,[_c(_setup.WHeaderProfile)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }